export default __webpack_public_path__ + "static/media/ikoni_yhteistyo.ebba7186.svg";